const ActionType = {
  GET_MODELS: 'models/get-models',
}

export default ActionType
